import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import VideoCard from '@/components/feature/VideoCard';
import { videos } from '@/mocks/videos';

export default function HotVideos() {
  const list = videos.slice(0, 6);

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="max-w-[1280px] mx-auto">
        <SectionHeading
          icon="ri-play-circle-line"
          title="热门趣味视频"
          subtitle="轻松搞笑，随时点开笑一笑"
          moreText="查看全部视频"
          morePath="/category/videos"
          accent="secondary"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {list.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>

        <div className="flex justify-center mt-8 sm:hidden">
          <Link
            to="/category/videos"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部视频
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}